import { render, staticRenderFns } from "./SearchThemeSelectorElement.vue?vue&type=template&id=979c05a6&"
import script from "./SearchThemeSelectorElement.vue?vue&type=script&lang=ts&"
export * from "./SearchThemeSelectorElement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports